<template>
  <el-dialog title="单位选择" width="900px" v-bind="$attrs" v-on="$listeners" :close-on-click-modal="false">
    <el-form ref="queryForm" v-model="queryForm" inline label-width="100px">
      <el-form-item label="单位名称">
        <el-input type="text" v-model="queryForm.compName" maxlength="50"
                  placeholder="请输入单位名称模糊查询" style="width:200px"></el-input>
      </el-form-item>
      <el-form-item class="button-container" label-width="0px">
        <el-button type="primary" @click="query()" icon="fa fa-search" :loading="loading">
          查询
        </el-button>
      </el-form-item>
    </el-form>
    <el-table :data="records" :border="true" v-loading="loading">
      <column-index></column-index>
      <el-table-column prop="compName" label="单位名称" min-width="300"></el-table-column>
      <column-code-type prop="compType" code-type="COMP_TYPE" label="单位类型" align="center" min-width="100"></column-code-type>
      <column-code-type prop="compLevel" code-type="areaLevel" label="单位层级" align="center" min-width="100"></column-code-type>
      <el-table-column prop="areaName" label="所属地区" align="center" min-width="150"></el-table-column>
      <el-table-column prop="log" label="选择" width="70" align="center">
        <template slot-scope="{ row, $index }">
          <el-button type="primary" size="small" @click="choose(row)">
            选择
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <table-pagination :page-query="queryForm" :total="total" @change="loadData"></table-pagination>
  </el-dialog>
</template>

<script>
import BaseVue from "@/components/base/BaseVue";
import TitleBar from "@/components/base/TitleBar";
import TablePagination from "@/components/base/TablePagination";
import CodeSelect from "@/components/base/CodeSelect";
import ColumnIndex from "@/components/tableColumns/ColumnIndex.vue";
import ColumnCodeType from "@/components/tableColumns/ColumnCodeType.vue";
import ColumnSelection from "@/components/tableColumns/ColumnSelection.vue";

export default {
  components: {ColumnSelection, ColumnCodeType, ColumnIndex, CodeSelect, TablePagination, TitleBar},
  extends: BaseVue,
  data() {
    return {
      records: [],
      total: 0,
      queryForm: {
        orgName: "",
        userName: "",
        page: 1,
        limit: 10
      }
    }
  },
  created() {
    this.query();
  },
  methods: {
    loadData() {
      this.loading = true;
      this.postForm("/company/getCompanyList", this.queryForm, true).then((dr) => {
        this.records = dr.rows || [];
        this.total = dr.total;
      }).finally(() => {
        this.loading = false;
      });
    },
    query() {
      this.queryForm.page = 1;
      this.loadData();
    },
    //选择
    choose(row) {
      this.$emit("choose", row);
    }
  }
}
</script>

<style scoped lang="scss">
</style>
